<template>
    <div class="header_top">
         <div class='header'>
            <div>
           <img style="margin-top:12px;" src="../assets/微信截图_20190926094653.png" alt="">
            </div>
            <div>
                <div v-for="(item,i) of title" :key='i' @click="fun(item.id,i)"><router-link :to='item.href' class="title"  >{{item.title}}</router-link></div>
                <div  @click="fun(item.id,i)">
                    <a href="http://oa.lusenky.com/#/login" target="_blank" class="title" rel="noopener noreferrer">OA管理</a>
                    </div>
            </div>
            <div>
                <div style="float:left;margin-top: 23px;margin-left:20px"><img src="../assets/dian.png" alt=""></div>
                <div><h3 class="wei2">010-56268817</h3></div>
            </div>
        </div>
    </div>
  
</template>
<script>
export default {
    data(){
        return{
            active:0,
            title:[
                {title:'首页',href:'/'},{title:'公司介绍',href:'/xiang/guan'},{title:'产品中心',href:'/chan'},{title:'工程案例',href:"/hang/Testing/",id:'gong'},{title:'资讯中心',href:'/hang/gong/0'},{title:'联系我们',href:'/xiang/lian'}
            ]
        }
    },
    methods:{
        fun(id,i){
     //   this.active=i
        let id1=document.getElementById(id)
        if(id1){
          id1.scrollIntoView()
        }
      }
    }
}
</script>
<style scoped>
.header{
    display: flex;
    width: 1200px;
    margin: 0 auto;
    padding: 15px 0;
    
}
.header_top{
    width:100%;
    background:#ffffff; 
    height: 108px;
    position: fixed;
    background: #ffffff;
    z-index: 999;
    /* margin:0 auto; */
}
.header>div:first-child,.header>div:last-child{
    width: 20%;
}
.header>div:nth-child(2){
    width: 60%;
    display: flex;
    justify-content: space-around;
  align-items: center;
}
.title{
    font-size: 14px;
    cursor: pointer;
}
.title:hover{
    color: red;
}
.wei{
   box-sizing: border-box;
   padding-left:58px;
   margin-top:18px;
   color:red; 
}
.active{
     color: red;
}
.wei2 {
    margin-top: 23px;
    font-size: 20px;
}

.wei2, .wei{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 58px;
    color: red;
}
</style>